import { CacheBase } from "../../core/baseEntity.model";
import { UserCache } from "../account/account.entity";
import { ClientCache } from "../client/client.entity";
import { AuthService } from "../core-services/auth.service";


export const AgendaCache = class extends CacheBase {

    static get canonical() {
        return 'ag';
     }

    static ref(userId: string = AuthService.instance.currentUser.uid) {
        return `${UserCache.ref(userId)}/${this.canonical}`
    }

    static clientRef(clientId: string, userId: string = AuthService.instance.currentUser.uid) {
        return `${ClientCache.ref(clientId, userId)}/${this.canonical}`;
    }

    static readonly child = {
        month: 'm',
        day: 'd'
    }
}